export const getGuestId = () => {
  let id = localStorage.getItem("guest_id");

  if (!id) {
    id = "guest_" + crypto.randomUUID();
    localStorage.setItem("guest_id", id);
  }

  return id;
};